import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const MyClientTeamNoPendingApprovalsLink = () => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_client_team_pending_approvals";
  const theme = useTheme();
  return (
    <>
      <Grid
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          color: theme.palette.primary.main,
        }}
      >
        <React.Fragment>
          <Grid style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
            <Typography variant="h5">
              <b>0</b>{" "}
            </Typography>
            <Typography variant="h5">{`${t(`${tRP}.pending`)}`}</Typography>
            <Typography variant="h5">{`${t(`${tRP}.approvals`)}`}</Typography>
          </Grid>
        </React.Fragment>
      </Grid>
    </>
  );
};
export default MyClientTeamNoPendingApprovalsLink;
